import { useNavigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS, useCheckPermissions, useLoaders } from '@/shared';
import { useGetPromocion } from '@/shared/actions/erp';
import { AlertSeverityEnum } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { SavePromocion } from '../../shared/components';

export type UpdatePromocionPageProps = {};

const UpdatePromocionPage: React.FC<UpdatePromocionPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_change_promocion);
  const returnUrlPromocionesPage =
    ROUTER_PATHS.administration.promocionesNav;
  const { id } = useParams();
  const navigate = useNavigate();
  const setAlert = useUiStore(state => state.setAlert);

  const { data, isLoading, isRefetching } = useGetPromocion(id!);
  useLoaders(isLoading || isRefetching);

  if (isLoading || isRefetching) return null;
  if (!data?.data.id_promocion) {
    setAlert(true, 'No se encontró la promoción', AlertSeverityEnum.error);
    navigate(returnUrlPromocionesPage);
    return;
  }

  return (
    <SavePromocion
      editPromocion={data.data}
      titlePage="Editar Promoción"
      isEditing={true}
    />
  );
};

export default UpdatePromocionPage;
